export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex items-center overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #e8fff2 0%, #f0fff7 40%, #ffffff 100%)' }}
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 right-20 w-96 h-96 rounded-full bg-[#03C75A]"></div>
        <div className="absolute bottom-20 left-10 w-64 h-64 rounded-full bg-[#03C75A]"></div>
      </div>

      {/* Background Image Right - hidden on mobile */}
      <div className="hidden sm:block absolute right-0 top-0 w-1/2 h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/3539aed1a115a38de4756da51ceb2fde.jpg"
          alt="머니박스 사무실"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#e8fff2] via-[#e8fff2]/60 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full pt-20 sm:pt-24 pb-12 sm:pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#03C75A]/10 border border-[#03C75A]/30 rounded-full px-3 sm:px-4 py-1.5 mb-4 sm:mb-6">
            <span className="w-2 h-2 bg-[#03C75A] rounded-full animate-pulse shrink-0"></span>
            <span className="text-xs sm:text-sm font-semibold text-black">네이버에서 머니박스대부중개 검색</span>
          </div>

          {/* Main Title */}
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-gray-900 leading-tight mb-3 sm:mb-4">
            신용카드 한도대출<br />
            <span className="text-gray-900">7년동안 한자리</span>운영 중
          </h1>
          <p className="text-base sm:text-xl text-gray-600 mb-2 sm:mb-3 font-medium">
            빠른 안전 보장 전국비대면 신용카드 대출 서비스
          </p>
          <p className="text-sm sm:text-base text-gray-500 mb-6 sm:mb-8 leading-relaxed">
            신용카드소지자대출 · 신용카드한도대출 · 신용카드잔여한도대출 · 신용카드비대면대출<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>법인카드대출 등 주식회사 머니박스대부중개의 신용카드대출을 안내해드립니다.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 mb-8 sm:mb-12">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleClick('#contact'); }}
              className="flex items-center justify-center gap-2 bg-[#03C75A] hover:bg-[#00A843] text-white font-bold px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-3-line"></i>
              무료 상담 신청
            </a>
            <a
              href="tel:01066065909"
              className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-[#03C75A] font-bold px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base border-2 border-[#03C75A] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              010-6606-5909
            </a>
          </div>

          {/* Trust Stats */}
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-3 sm:gap-6">
            {[
              { icon: 'ri-calendar-check-line', value: '7년+', label: '전문 운영' },
              { icon: 'ri-time-line', value: '24/365', label: '항상 상담 가능' },
              { icon: 'ri-shield-check-line', value: '100%', label: '비대면 처리' },
              { icon: 'ri-bank-card-line', value: '전카드', label: '카드대출 서비스' },
            ].map((stat) => (
              <div key={stat.value} className="flex items-center gap-2 sm:gap-3 bg-white/80 backdrop-blur-sm rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-100">
                <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center shrink-0">
                  <i className={`${stat.icon} text-lg sm:text-xl text-[#03C75A]`}></i>
                </div>
                <div>
                  <div className="text-base sm:text-lg font-black text-gray-900">{stat.value}</div>
                  <div className="text-xs text-gray-500">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-xs text-gray-400">스크롤</span>
        <i className="ri-arrow-down-line text-[#03C75A] text-lg"></i>
      </div>
    </section>
  );
}
